import { render, staticRenderFns } from "./jy-onTheShelvesDetail.vue?vue&type=template&id=06c747eb&scoped=true&"
import script from "./jy-onTheShelvesDetail.vue?vue&type=script&lang=js&"
export * from "./jy-onTheShelvesDetail.vue?vue&type=script&lang=js&"
import style0 from "./jy-onTheShelvesDetail.vue?vue&type=style&index=0&id=06c747eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c747eb",
  null
  
)

export default component.exports